import React, { useCallback } from 'react'
import { Alert, Button, Modal } from 'antd'
import { useIntl } from 'react-intl'

import { LAZADA_SERVICE_MARKETPLACE_URL } from 'utils/static'

export const useLazadaReconnectConfirm = () => {
  const { formatMessage } = useIntl()

  return useCallback(() => {
    Modal.confirm({
      title: formatMessage({ id: 'marketplaceConnect.lazada_reconnect_title' }),
      content: formatMessage({ id: 'marketplaceConnect.lazada_reconnect_description' }),
      okText: formatMessage({ id: 'marketplaceConnect.lazada_reconnect_confirm' }),
      cancelText: formatMessage({ id: 'marketplaceConnect.lazada_reconnect_cancel' }),
      maskClosable: true,
      onOk: () => {
        window.location.href = LAZADA_SERVICE_MARKETPLACE_URL
      },
    })
  }, [formatMessage])
}

const LazadaReconnectAlert = ({ count, className, closable }) => {
  const { formatMessage } = useIntl()
  const showConfirm = useLazadaReconnectConfirm()

  return (
    <Alert
      className={className}
      type="warning"
      showIcon
      closable={closable}
      message={formatMessage(
        { id: 'marketplaceConnect.lazada_reconnect_banner' },
        {
          count,
          reconnect: (
            <Button
              type="link"
              size="small"
              style={{ padding: 0, height: 'auto' }}
              onClick={showConfirm}
            >
              <strong>{formatMessage({ id: 'marketplaceConnect.lazada_reconnect_button' })}</strong>
            </Button>
          ),
        },
      )}
    />
  )
}

export default LazadaReconnectAlert
